import { render, staticRenderFns } from "./areaService.vue?vue&type=template&id=0b80da76&scoped=true&"
import script from "./areaService.vue?vue&type=script&lang=js&"
export * from "./areaService.vue?vue&type=script&lang=js&"
import style0 from "./areaService.vue?vue&type=style&index=0&id=0b80da76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b80da76",
  null
  
)

export default component.exports